import { createV3Queries } from "@query/utils/createV3Queries";
import { backgroundChecksApi } from "@api";
import { getRequirementsDependencies } from "../../modules/Requirements/dependencies";

/**
 * Background-check registry — mirrors `BackgroundChecksApi` 1:1
 * (`/v3/compliance/background-checks`). Background checks back
 * `BackgroundCheck` requirement instances, so ordering or cancelling one
 * fans out into the requirement reads.
 */
export const queriesBackgroundChecks = createV3Queries(
  "backgroundChecksApi",
  backgroundChecksApi,
  {
    createBackgroundCheck: () => ({
      dependencies: () => getRequirementsDependencies()
    }),
    cancelBackgroundCheck: () => ({
      dependencies: () => getRequirementsDependencies()
    })
  }
);
